module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71016/img/case-study-zero.png"